import defaultImg from "../image/v2/defaultImg.png";

// 파라미터 값 가져오기
export function getParameter(key) {
  return new URLSearchParams(window.location.search).get(key);
}

// 팝업 열기
export function openPopup(name) {
  document.getElementById(name).classList.remove("hide");
}
export function closePopup(name) {
  document.getElementById(name).classList.add("hide");
}
export function reloadPopup() {
  window.location.reload();
}
// 이미지가 없을 경우
export function handleImgError(e) {
  e.target.src = defaultImg;
}

// 텍스트 변경
export function formatText(text, tagId) {
  if(text) {
    let p = document.createElement("p");
    let textBox = document.getElementById(tagId);

    p.innerHTML = text.replace(/\n/ig, "<br />");
    textBox.appendChild(p);
  } else {
    return false;
  }
}

export function formatAdminDelivery(deliveryType) {
  const deliveryList = ["바로배달", "방문포장", "묶음배송", "택배배송", "예약"];

  let formattedDelivery = "";

  if(deliveryType) {
    for(let i = 0; deliveryType.length > i; i++) {
      formattedDelivery += deliveryList[i] + ', '
    }
    formattedDelivery = formattedDelivery.slice(0, -2)
  }

  return formattedDelivery;
}



// 날짜 시간 구하기
export function getTodayDateTime() {
  let today = new Date();
  let year = today.getFullYear();
  let month = ('0' + (today.getMonth() + 1)).slice(-2);
  let day = ('0' + today.getDate()).slice(-2);
  let hours = ('0' + today.getHours()).slice(-2);
  let minutes = ('0' + today.getMinutes()).slice(-2);
  let seconds = ('0' + today.getSeconds()).slice(-2);

  return `${ year }-${ month }-${ day } ${ hours }:${ minutes }:${ seconds }`
}
// 오늘날짜 구하기
export function getToday() {
  let date = new Date();
  let year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, '0');
  let day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
// 내일날짜 구하기
export function getNextDay() {
  let today = new Date();
  let date = new Date(today.setDate(today.getDate() + 1));
  let year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, '0');
  let day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
// 현재 시간 구하기
export function getTime() {
  const today = new Date()
  const hours = String(today.getHours()).padStart(2, '0');
  const minutes = String(today.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`
}

// 금액 형식 변경
export function formatCost(cost) {
  let formatCost = "0";
  if(cost) {
    formatCost =  String(cost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return formatCost;
}

// id 값 가져오기
export const getValue = (id) => {
  return document.getElementById(id).value;
}
// id 값 변경
export const setValue = (id, value) => {
  document.getElementById(id).value = value;
}
export const getChecked = (id) => {
  return document.getElementById(id).checked;
}
export const setChecked = (id, value) => {
  document.getElementById(id).checked = value;
}
// 데이터 값 가져오기
export const getAttr = (id, name) => {
  return document.getElementById(id).getAttribute(name);
}

// input 박스 입력값 제한
const numberInputRegex = /[^0-9]/gi;
const engInputRegex = /[^a-zA-Z0-9_.]/gi;
export const inputLimit = () => {
  const applyInputLimit = (element, regex) => {
    element.addEventListener("focusout", function () {
      let inputValue = element.value;
      if (inputValue.length > 0) {
        if (inputValue.match(regex)) {
          inputValue = inputValue.replace(regex, "");
        }
        element.value = inputValue;
      }
    });

    element.addEventListener("input", function () {
      element.value = element.value.replace(regex, "");
    });
  };

  const numberElements = document.querySelectorAll(".number");
  numberElements.forEach((element) => applyInputLimit(element, numberInputRegex));

  const engElements = document.querySelectorAll(".eng");
  engElements.forEach((element) => applyInputLimit(element, engInputRegex));
};

// input 박스 최대 입력 길이 제한
export const inputMaxLength = (e) => {
  const inputValue = e.target.value;
  if (inputValue.length > e.target.maxLength) {
    e.target.value = inputValue.slice(0, e.target.maxLength);
  }
};


export const pagingBtn = (page, listCount, count, url) => {
  const lastPage = parseInt(listCount / count);
  const remainder = listCount % count;
  const paging = remainder !== 0 ? lastPage : lastPage - 1;

  let pageList = [];

  if(page < 3) {
    pageList = [1, 2, 3, 4, 5]
  } else if(paging >= page + 2) {
    pageList = [page - 1, page, page + 1, page + 2, page + 3]
  } else {
    pageList = [paging - 3, paging - 2, paging - 1, paging, paging + 1]
  }

  const pagingList = document.getElementById("pagingList");

  pageList.forEach((value) => {
    if(value > 0) {
      const li = document.createElement("li");
      li.innerHTML = `<button class="pageBtn ${page + 1 === value ? "active" : ""}">${value}</button>`;
      li.setAttribute("class", "pagingBtn");
      li.addEventListener("click", () => {
        pagingBtnEvent(url, value - 1);
      })

      if (paging + 1 >= value) {
        pagingList.appendChild(li);
      }
    }
  })

  document.querySelector(".pageStartBtn").addEventListener("click", () => {
    pagingBtnEvent(url, 0);
  })
  document.querySelector(".pageEndBtn").addEventListener("click", () => {
    pagingBtnEvent(url, paging);
  })
}

export const pagingBtn2 = (page, listCount, count, url) => {
  const lastPage = parseInt(listCount / count);
  const remainder = listCount % count;
  const paging = remainder !== 0 ? lastPage : lastPage - 1;

  let pageList = [];

  if(page < 3) {
    pageList = [1, 2, 3, 4, 5]
  } else if(paging >= page + 2) {
    pageList = [page - 1, page, page + 1, page + 2, page + 3]
  } else {
    pageList = [paging - 3, paging - 2, paging - 1, paging, paging + 1]
  }

  const pagingList = document.getElementById("pagingList");

  pageList.forEach((value) => {
    if(value > 0) {
      const li = document.createElement("li");
      li.innerHTML = `<button class="pageBtn ${page === value ? "active" : ""}">${value}</button>`;
      li.setAttribute("class", "pagingBtn");
      li.addEventListener("click", () => {
        pagingBtnEvent(url, value);
      })

      if (paging + 1 >= value) {
        pagingList.appendChild(li);
      }
    }
  })

  document.querySelector(".pageStartBtn").addEventListener("click", () => {
    pagingBtnEvent(url, 1);
  })
  document.querySelector(".pageEndBtn").addEventListener("click", () => {
    pagingBtnEvent(url, paging + 1);
  })
}

export const pagingBtnEvent = (url, page) => {
  window.location.href = `${url}&page=${page}`;
}

// 셀렉트 버튼 이벤트
export const selectBtnEvent = (e) => {
  // 모든 셀렉트 박스 비활성화
  const selectOptionListBox = document.querySelectorAll(".selectOptionListBox");
  selectOptionListBox.forEach((element) => {
    element.style.display = "none";
  });
  // 셀렉트 텍스트 박스 클릭 시 타켓 셀렉트 박스 활성화
  if(e.target.classList.contains("selectTextBox")) {
    const targetId = e.target.getAttribute("data-href");
    const targetElement = document.getElementById(targetId);
    const listBox = document.getElementById(`${targetId}Ul`);

    const rect = targetElement.getBoundingClientRect();
    const x = rect.left;
    const y = rect.top;
    const width = rect.width;

    listBox.style.width = `${width - 10}px`;
    listBox.style.display = "block";
    listBox.style.top = `${y}px`;
    listBox.style.left = `${x}px`;
  }
}

// 이미지 변환
export const imageChangeEvent= (e, maxSize, type, fileName, previewName, fileList, setFileList) => {
  const file = e.target;

  // 파일 확장자 확인
  const allowedExtensions = ["jpg", "jpeg", "png", "gif"];
  const fileExtension = file.files[0].name.split(".").pop().toLowerCase();

  if (!allowedExtensions.includes(fileExtension)) {
    alert("이미지 파일만 등록할 수 있습니다.");
    return false;
  }

  // 파일 형식 변환
  const fileReader = new FileReader();
  fileReader.onload = (base64) => {
    const image = new Image();
    image.src = base64.target.result;

    image.onload = (e) => {
      // 파일 최대 사이즈에 맞춰 이미지 크기 변경
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const { width, height } = imageSizeEvent(e, maxSize);

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(e.target, 0, 0, width, height);

      // 이미지 데이터를 JPEG 형식으로 변환
      const fileInfo = canvas.toDataURL("image/jpeg", 1);

      // 파일 정보 구성
      const arr1 = file.files[0].name.split(".");
      const arr2 = fileInfo.split(",");
      const fileId = Number(file.dataset.id);
      const fileIndex = Number(file.dataset.index);

      // 중복된 fileId 제거
      const filteredFileList = fileList.filter(item => item.id !== fileId);

      const fileImage = {
        index: fileIndex,
        id: fileId === 0 ? undefined : fileId,
        imageType: type,
        encodedFile: arr2[1],
        fileName: `${arr1[0]}_${type}`,
        fileExtension: "jpg"
      };

      // 업로드된 파일명 표시
      if(fileName !== "") {
        document.getElementById(fileName).value = file.files[0].name;
      }
      // 미리보기 표시
      if(previewName !== "") {
        document.getElementById(previewName).setAttribute("src", fileInfo);
        document.getElementById(previewName).setAttribute("data-id", "0");
      }

      // 파일 리스트에 저장
      setFileList(prev => {
        const filtered = prev.filter(file => file.imageType !== 6);
        return [...filtered, fileImage];
      });
    }
  }
  fileReader.readAsDataURL(file.files[0]);
}

// 이미지 사이즈 변환
export const imageSizeEvent = (e, maxSize) => {
  let { width, height } = e.target;

  if(width > height) {
    if (width > maxSize) {
      height *= maxSize / width;
      width = maxSize;
    }
  } else {
    if (height > maxSize) {
      width *= maxSize / height;
      height = maxSize;
    }
  }

  return { width, height };
}

// id로 배열 삭제
export const removeArrayById = (arr, idToRemove) => {
  // 배열을 순회하며 id값이 일치하지 않는 배열만 새로운 배열에 유지합니다.
  return arr.filter(subArr => subArr.id !== idToRemove);
}
// id로 배열 삭제
export const removeArrayByIndex = (arr, idToRemove) => {
  // 배열을 순회하며 id값이 일치하지 않는 배열만 새로운 배열에 유지합니다.
  return arr.filter(subArr => subArr.index !== idToRemove);
}